module.exports = __webpack_public_path__ + "img/coronavirus2.6f8f732e.jpg";